// Which product this page load is for.
//
// One build serves both verticals. Django mounts the same SPA at /flights/* and
// /hotels/* (see root/urls.py), and the router picks its basename off the URL
// prefix — so `<Link to="/results">` resolves to /hotels/results on a hotel page
// and /flights/results on a flight one, with no per-link branching.
//
// The consequence to remember: react-router can only navigate WITHIN a
// basename. Crossing verticals is a full page load, which is what `hrefFor`
// below is for — a <Link> would resolve against the wrong prefix and 404.

export type Vertical = "flights" | "hotels";

export const VERTICALS: Array<{ key: Vertical; label: string; basename: string }> = [
  { key: "flights", label: "Flights", basename: "/flights" },
  { key: "hotels", label: "Hotels", basename: "/hotels" },
];

export function currentVertical(): Vertical {
  return window.location.pathname.startsWith("/hotels") ? "hotels" : "flights";
}

export function basename(): string {
  return currentVertical() === "hotels" ? "/hotels" : "/flights";
}

/** An absolute href for a path in another vertical. Use with <a>, not <Link>. */
export function hrefFor(vertical: Vertical, path = "/"): string {
  const root = vertical === "hotels" ? "/hotels" : "/flights";
  return path === "/" ? `${root}/` : `${root}${path.startsWith("/") ? path : `/${path}`}`;
}
